import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { TaskKanbanStatus } from "@/modules/tasks/core/constants/taskKanbanStatus"
import { CandidateAllocationPeriod } from "./candidateAllocationPeriod"
import { EndAssignmentReason } from "@/modules/assignments/constants/endAssignmentReason"
import { CandidateSignalStatus } from "../constants/CandidateSignalStatus"
import { CandidateSignalAction } from "../constants/CandidateSignalAction"
import { ConsultantStatus } from "@/modules/consultants/constants/consultantStatus"
import { EngagementType } from "@/modules/tasks/active/constants/engagementType"
import { ServiceType } from "@/modules/tasks/active/constants/serviceType"
import { UserModel } from "@/modules/users/models/userModel"

@Serializable
export class CandidateListView {
  uid: string = ""
  name: string = ""
  email: string = ""
  phone: string = ""
  title: string = ""
  updatedAt: string = ""
  companyName: string = ""
  companyId: string = ""
  kanbanStatus: number = TaskKanbanStatus.NotDefined
  endReason: number = EndAssignmentReason.NotDefined
  periods: CandidateAllocationPeriod[] = []
  negotiationState: number = 0
  signalStatus: CandidateSignalStatus = CandidateSignalStatus.OnTrack
  signalAction: CandidateSignalAction = CandidateSignalAction.NoActionRequired
  status: ConsultantStatus = ConsultantStatus.Active
  serviceType: ServiceType = ServiceType.Consultant
  engagementType: EngagementType = EngagementType.TimeAndMaterial
  startDate: string = ""
  endDate: string = ""
  supplierName: string = ""
  requesterName: string = ""
  requester: UserModel = new UserModel()
  responsibleName: string = ""
  location: string = ""
  /** GITCS/internal consultant. Same signal as CandidateModel.isInternal (drawer banners). */
  isInternal: boolean = false
  /** Current contract uid, or "" when the engagement has none. Kebab actions act on it. */
  contractId: string = ""
  /** Current extension request uid, or "" when there is none. */
  extensionId: string = ""
  endRequestId: string = ""

  constructor(data: Partial<CandidateListView> | null = null) {
    if (data) {
      Object.assign(this, data)
      this.periods = (data.periods ?? []).map(
        (period) => new CandidateAllocationPeriod(period),
      )
    }
  }
}
